export type NotificationType = "success" | "error" | "warning" | "info";

export interface INotification {
  id: number;
  type: NotificationType;
  message: string;
  createdAt: number;
}

export type NotificationListener = (notification: INotification) => void;

let _listener: NotificationListener | null = null;
let _idCounter = 0;

/**
 * Surface methods accept extra trailing args (`title`, `timeOut`, etc.) for
 * compatibility with the legacy react-notifications API used by some callers
 * (e.g. useWebSocket). The local implementation only consumes `message` and
 * silently drops the rest. // TODO(ts-tighten): tighten the surface in Phase 7
 * once the legacy 3-arg sites are migrated to use only the message.
 */
export const NotificationManager = {
  _setListener(fn: NotificationListener | null): void {
    _listener = fn;
  },

  _emit(type: NotificationType, message: string): void {
    if (_listener) {
      _listener({ id: ++_idCounter, type, message, createdAt: Date.now() });
    }
  },

  success(message: string, ..._rest: unknown[]): void {
    this._emit("success", message);
  },

  error(message: string, ..._rest: unknown[]): void {
    this._emit("error", message);
  },

  warning(message: string, ..._rest: unknown[]): void {
    this._emit("warning", message);
  },

  info(message: string, ..._rest: unknown[]): void {
    this._emit("info", message);
  },
};
